<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:14:49
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-06-02 09:01:46
 * @Description: 统计数据卡片模块--季度
 -->
<template>
  <div class="observe-data">
    <div class="observe-data__card-container-1">
      <num-card :total="cloudView" danwei="景" name="本季拍摄" color="#F74C32" bgcolor="#FDF2F1"/>
      <num-card :total="cloudSize" danwei="T" name="本季拍摄" color="#7A73FF" bgcolor="#F1F0FD" />
      <num-card :total="cloudCover" danwei="%" name="本季覆盖" color="#45AAFB" bgcolor="#F7FDFF"/>
    </div>
    <div class="observe-data__card-container-2">
      <num-card :total="pushView" danwei="景" name="本季推送" color="#29B7A3" bgcolor="#F7FFFE"/>
      <num-card :total="pushSize" danwei="T" name="本季推送" color="#EB4DDB" bgcolor="#FCF7FF"/>
      <num-card :total="pushBatch" danwei="批" name="本季推送" color="#F78704" bgcolor="#FFF9F2"/>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import NumCard from '@/components/num-card'

import {
  GET_STATISTICS,
  GET_STATISTIC_HELP,
} from '@/assets/const-value/interface'

moment.locale('fr', {
  week: {
    dow: 1, // 星期一是一周的第一天
    doy: 4, // 判断一年中的第一周
  },
})
export default {
  components: {
    NumCard,
  },
  data() {
    return {
      cloudView: 0,
      cloudSize: 0,
      cloudCover: 0,
      pushView: 0,
      pushSize: 0,
      pushBatch: 0,
    }
  },
  created() {
    this.getStatistics()
  },
  methods: {
    /**
     * 获取覆盖率数据
     */
    async getStatistics() {
      const year = moment().year()
      const periodType = 2 // quarter
      const month = moment().month() + 1
      let period = null
      if (month < 4) {
        period = `${moment().year()}01`
      } else if (month < 7) {
        period = `${moment().year()}02`
      } else if (month < 10) {
        period = `${moment().year()}03`
      } else {
        period = `${moment().year()}04`
      }
      const typeAcquistion = 2 // 采集
      const typePush = 3 // push
      const regionIdOrPushuser = '100000' // 中国
      const regionIdOrPushuserGlobal = '-' // 全球
      const satelliteGroupId19 = 19

      // 本季推送
      this.$axios.get(GET_STATISTICS({
        year, periodType, period, satelliteGroupId: satelliteGroupId19, type: typePush, regionIdOrPushuser: regionIdOrPushuserGlobal,
      })).then((res) => {
        if (res.code === 0) {
          this.pushView = res.data.children.length ? res.data.children[0].numCurrent : 0
          this.pushSize = res.data.children.length ? (res.data.children[0].sizeCurrent / 1024 / 1024 / 1024 / 1024).toFixed(2) : 0
          this.pushBatch = res.data.children.length ? res.data.children[0].batchNumCurrent || 0 : 0
        }
      }).catch(err => console.error(err))

      // 本季度分卫星采集拍摄
      const satellites = [
        { value: 6, name: '可见光' },
        // { value: 106, name: 'ZY1-02C' },
        { value: 116, name: 'ZY1-02D' },
        { value: 52, name: 'ZY1-02E' },
        // { value: 111, name: 'ZY3-01' },
        { value: 115, name: 'ZY3-02' },
        { value: 118, name: 'ZY3-03' },
        { value: 7, name: '2m/8星' },
        { value: 109, name: 'GF-1' },
        { value: 92, name: 'GF-2' },
        { value: 55, name: 'GF-5A' },
        { value: 54, name: 'GF-5B' },
        { value: 91, name: 'GF-6' },
        { value: 105, name: 'GF-7' },
        { value: 119, name: 'CBERS-04A' },
        { value: 122, name: 'L-SAR' },
      ]
      const satellitesIds = satellites.map(i => i.value)
      this.$axios.get(GET_STATISTIC_HELP, {
        params: {
          year, type: periodType, length: 1, regionId: regionIdOrPushuser, taskType: typeAcquistion, satelliteIds: satellitesIds.join(),
        },
      }).then((res) => {
        if (res.code !== 0) throw new Error('bad request in sta-image')
        // -------- 当期 -------
        const satellite6 = res.data.find(x => x.satelliteId === 6)
        if (satellite6) {
          const cover = satellite6.data.length ? satellite6.data[0].coveragePercentCurrent || 0 : 0
          const cloudViewAdd = satellite6.data.length ? satellite6.data[0].numCurrent : 0
          const cloudSizeAdd = satellite6.data.length ? satellite6.data[0].sizeCurrent : 0
          this.cloudCover = (cover).toFixed(2)
          this.cloudView = cloudViewAdd
          this.cloudSize = (cloudSizeAdd / 1024 / 1024 / 1024 / 1024).toFixed(2)
        }
        // -------- 分卫星 -------
        const satelliteOther = res.data.filter(x => x.satelliteId !== 6).sort((a, b) => {
          const orderb = satellitesIds.indexOf(a.satelliteId) - satellitesIds.indexOf(b.satelliteId)
          return orderb
        })
        const names = [ 'ZY1-02D', 'ZY1-02E', 'ZY3-02', 'ZY3-03', '2m/8m星', 'GF-1', 'GF-2', 'GF-5A', 'GF-5B', 'GF-6', 'GF-7', 'CBERS-04A', 'L-SAR' ]
        const satelliteView = []
        const satelliteCover = []
        satelliteOther.forEach((item, i) => {
          const obj = {
            name: names[i],
            value: item.data.length ? item.data[0].numCurrent || 0 : 0,
          }
          const cover = {
            name: names[i],
            value: (item.data.length ? item.data[0].coveragePercentCurrent || 0 : 0).toFixed(2),
          }
          satelliteView.push(obj)
          satelliteCover.push(cover)
        })
        this.$store.commit('page/SET_SEASON_SATELLITE_COVER', satelliteCover)
        this.$store.commit('page/SET_SEASON_SATELLITE_VIEW', satelliteView)
      }).catch((err) => {
        console.error('获取分卫星统计失败', err)
      })
    },
  },
}
</script>
